import { useState } from 'react';
import Reveal from '@/components/feature/Reveal';

const HIGHLIGHTS = [
  { id: 'i-1', icon: 'ri-chat-3-line', text: '每个热门话题下都有正反两面的完整评论' },
  { id: 'i-2', icon: 'ri-search-eye-line', text: '细节研究所负责把截图、音轨与线索整理归档' },
  { id: 'i-3', icon: 'ri-time-line', text: '待确认的说法会被单独标记，不混进结论里' },
];

export default function JoinCta() {
  const [joined, setJoined] = useState(false);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-50">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="p-6 md:p-9 lg:col-span-7">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs text-primary-800">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-group-line text-xs" />
                  </span>
                  现在有 12,486 位吃瓜群众在线
                </span>
                <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                  别只自己看，把观点也留在评论里
                </h3>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700">
                  你在别的平台看到的热闹，在这里可以接着聊。发一条观点，翻一遍评论，也许下一个被大家转发的细节，就是你发现的。
                </p>

                <div className="mt-6 flex flex-col gap-2 sm:flex-row">
                  <button
                    type="button"
                    onClick={() => setJoined(true)}
                    className="h-11 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    {joined ? '已提交，等待审核（演示）' : '申请加入讨论'}
                  </button>
                  <a
                    href="#trending"
                    className="flex h-11 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-100"
                  >
                    先逛逛热榜
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line text-base" />
                    </span>
                  </a>
                </div>
                {joined && (
                  <p className="mt-3 text-xs text-foreground-600">
                    这里是演示效果，正式版本会引导你完成注册流程后再参与讨论。
                  </p>
                )}
              </div>

              <div className="border-t border-primary-200 p-6 md:p-9 lg:col-span-5 lg:border-l lg:border-t-0">
                <p className="text-xs font-medium tracking-widest text-primary-800">JOIN / 你能得到什么</p>
                <ul className="mt-4 flex flex-col gap-3">
                  {HIGHLIGHTS.map((item) => (
                    <li
                      key={item.id}
                      className="flex items-start gap-3 rounded-md border border-background-200 bg-background-50 p-3.5"
                    >
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                        <i className={`${item.icon} text-base`} />
                      </span>
                      <span className="text-sm leading-relaxed text-foreground-800">{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}